import SectionHeader from './SectionHeader';

const stats = [
  { num: '1286+', label: '已收录表情包', icon: 'ri-emotion-laugh-line' },
  { num: '360+', label: '热门事件专题', icon: 'ri-fire-line' },
  { num: '98万', label: '网友转发收藏', icon: 'ri-share-circle-line' },
  { num: '24h', label: '实时滚动上新', icon: 'ri-time-line' },
];

const quotes = [
  { name: '瓜田里的一只猹', text: '摸鱼必备！每次开会被困住，全靠每日看瓜的表情包续命，已经存了三百多张。', tag: '摸鱼达人' },
  { name: '干饭第一名', text: '新瓜刚爆一小时这里就有配套图了，群友都问我从哪下的，笑死，饭都变香了。', tag: '死忠粉' },
  { name: '退堂鼓演奏家', text: '神评论比段子本体还好笑，老板不在的时候刷完一条龙，工位快乐老家。', tag: '长期蹲守' },
];

const principles = ['不搞标题党、不传谣造谣', '网友二创一律署名并设置举报通道', '热门事件持续跟新，不漏瓜', '图源清晰无水印，方便直接存用'];

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          kicker="📖 认识每日看瓜"
          title="全网吃瓜的表情包弹药库"
          desc="一个专注热门事件的梗图仓库：表情包、段子、神评论与网友二创，按事件沉淀、按分类归档，随取随用。"
        />

        {/* 数据墙 */}
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-3xl bg-background-100 p-6 text-center ring-1 ring-background-200">
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-accent-100 text-accent-700"><i className={`${s.icon} text-2xl`}></i></span>
              <p className="mt-4 font-display text-3xl font-bold text-primary-600">{s.num}</p>
              <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {/* 内容原则 */}
          <div className="rounded-3xl bg-background-100 p-7 ring-1 ring-background-200">
            <h3 className="flex items-center gap-2 font-heading text-2xl text-foreground-950"><span className="text-3xl">🛡️</span>内容原则</h3>
            <ul className="mt-5 space-y-3.5">
              {principles.map((p) => (
                <li key={p} className="flex items-start gap-3 text-foreground-700">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500 text-xs text-background-50"><i className="ri-check-line"></i></span>
                  {p}
                </li>
              ))}
            </ul>
            <p className="mt-5 rounded-2xl bg-background-50 p-4 text-sm leading-relaxed text-foreground-600 ring-1 ring-background-200">
              我们相信：好的吃瓜不止于热闹，更要有分寸。每日看瓜坚持<b className="font-bold text-foreground-800">快乐分享、尊重原创、理性围观</b>，
              让每张图、每句话都发得出手、接得住梗。
            </p>
          </div>

          {/* 用户口碑 */}
          <div className="rounded-3xl bg-primary-500 p-7 text-background-50">
            <h3 className="flex items-center gap-2 font-heading text-2xl"><span className="text-3xl">💛</span>蹲瓜人的真心话</h3>
            <div className="mt-5 space-y-4">
              {quotes.map((q) => (
                <div key={q.name} className="rounded-2xl bg-background-50/12 p-4">
                  <p className="text-sm leading-relaxed text-background-50/95">“{q.text}”</p>
                  <p className="mt-2.5 flex items-center gap-2 text-xs text-background-50/75">
                    <i className="ri-account-circle-fill text-base"></i>
                    <span className="font-bold">{q.name}</span>
                    <span className="rounded-full bg-background-50/20 px-2 py-0.5">{q.tag}</span>
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}